import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OpporunityDetailsComponent } from './opporunity-details.component';

const routes: Routes = [{ path: '', component: OpporunityDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OpporunityDetailsRoutingModule {}
